import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { DateRange } from './date-range';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { DATE_FORMAT } from '../utils/dateUtils';
import { DateRangePickerTranslations } from './DateRangePickerTranslations';
import * as uuid from 'uuid';

@Component({
  selector: 'cc-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
})
export class DateRangePickerComponent implements OnInit {
  private options;
  private format = 'YYYY-MM-DD HH:mm:ss';
  private formatOutput = 'YYYY-MM-DDTHH:mm:ss';
  private dateRange: DateRange = {} as DateRange;
  private translations: DateRangePickerTranslations;
  public inputId = uuid.v4();

  @Input() timePicker = true;
  @Input() minDate: Date;
  @Input() startDate: Date = new Date();
  @Input() endDate: Date = new Date();
  @Input() maxDate: Date = new Date();
  @Input() opens: string;
  @Output() selected = new EventEmitter<DateRange>();

  constructor(
    private configService: ConfigService,
    public translate: TranslateService,
    public languageService: LanguageService
  ) {}

  ngOnInit() {
    this.configureDateFormat();
    this.updateTranslations();
    this.languageService.onLanguageChange.subscribe(() => {
      this.updateTranslations();
    });
  }

  get pickerOptions() {
    return {
      ...this.options,
      minDate: this.minDate || undefined,
      startDate: this.startDate || undefined,
      endDate: this.endDate || undefined,
      maxDate: this.maxDate || undefined,
      opens: this.opens || undefined,
    };
  }

  updateTranslations() {
    const currentLang = this.translate.currentLang || 'en';
    this.translations = {
      translatedMonths: this.configService.getValue('months')[currentLang],
      translatedRanges: this.configService.getValue('dateRanges')[currentLang],
    };
    this.options = {
      timePicker: this.timePicker,
      applyClass: 'primary',
      cancelClass: 'warn',
      opens: 'left',
      alwaysShowCalendars: true,
      showCustomRangeLabel: false,
      locale: {
        format: this.format,
        monthNames: this.translations.translatedMonths,
      },
      ranges: this.translations.translatedRanges,
      startDate: this.startDate,
      endDate: this.endDate,
      maxDate: this.maxDate,
      minDate: this.minDate || undefined,
    };
  }

  configureDateFormat() {
    if (!this.timePicker) {
      this.format = DATE_FORMAT;
      this.formatOutput = DATE_FORMAT;
    }
  }

  selectedDate(value) {
    this.dateRange.dateFrom = value.start.format(this.formatOutput);
    this.dateRange.dateTo = value.end.format(this.formatOutput);
    this.selected.next(this.dateRange);
  }
}
